import { PushNotificationServiceStatus } from '../constants/push-notification-service-status';

const isConnected = (status: PushNotificationServiceStatus) =>
    (status === PushNotificationServiceStatus.connected || status === PushNotificationServiceStatus.reconnected);

export const notificationUtils = {
    isConnected
};
